/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { LatLng } from './lat-lng.class';
import { MarkerInfo } from './marker-info.class';
import { IMarkerOptions } from './marker-options.interface';
import { EPlotType } from './plot-type.enum';
import { EDeviceErrorType, EVehicleStatusType } from './vehicle-status-type.enum';

export class VehicleMarkerInfo extends MarkerInfo {
  constructor(
    public id: number,
    public latLng: LatLng,
    public title: string,
    public type: EPlotType,
    public status: EVehicleStatusType,
    public driverId: number,
    public hasNavigationDevice: boolean,
    public options: IMarkerOptions,
    public deviceErrorStatuses?: EDeviceErrorType[],
    public shape?: google.maps.Polygon | google.maps.Circle
  ) {
    super(id, latLng, title, type, options, null);
  }
}
